import { AxiosResponse } from "axios";
import { API_ROUTE } from "../const/apiRoute";
import { NotificationExtension } from "../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../_base/extension/StringExtension";
import { HanderResponse } from "../_base/helper/FunctionHelper";
import { api } from "../library/axios";
import { modals } from "@mantine/modals";

export const createUserReview = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.CREATE_USER_REVIEW,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Gửi đánh giá thành công");
    } else if (response != null)
      NotificationExtension.Fails("Gửi đánh giá thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDataUserReview = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      `${API_ROUTE.GET_LIST_USER_REVIEW}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDataUserReviewDetail = async (id: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      `${API_ROUTE.GET_USER_REVIEW_DETAIL}${id}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyUserReview = async (
  data: any,
  onClose: any
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.MODIFY_USER_REVIEW,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Chỉnh sửa đánh giá thành công");
      onClose((prev: any) => !prev);
      modals.closeAll();
    } else if (response != null)
      NotificationExtension.Fails("Chỉnh sửa đánh giá thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const deleteUserReview = async ({
  data,
  onClose,
}: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.DELETE_USER_REVIEW,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Xóa thành công !");
      onClose((prev: any) => !prev);
    } else if (response != null) NotificationExtension.Fails("Xóa thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyDisableUserReview = async (id: number): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      `${API_ROUTE.MODIFY_DISABLE_USER_REVIEW}${id}`
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Chỉnh sửa thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Chỉnh sửa thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};


export const UpdatefilexcelReview= async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_FILEEXCEL_USER_REVIEW,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Cập nhật thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};